import { drawerProfile } from "./drawer-profile";

export const drawers = {
	drawerProfile,
	editData: "Edit information",
	viewlinkedplaces: "View linked places",
	drawerCouvert: {
		code: "SKU",
		couvertGeneralData: "Couvert General Data",
		taxGroup: "Tax Group",
		taxProfile: "Tax Profile",
	},
	drawerGroup: {
		excludeTaxGroup: "Delete group",
		titles: {
			generalData: "General data",
			vat: "VAT",
			service: "Service",
		},
		fiscalProductGroupType: {
			vat: "VAT Portugal",
			vatFactura: "VAT Mexico",
			vatSpain: "VAT Spain",
			service: "Service",
			serviceNational: "National Service",
			invoice: "Invoice",
		},
		fields: {
			taxRate: {
				label: "Tax Rate (%)",
			},
			code: {
				label: "SKU",
			},
			productType: {
				label: "Product Type",
			},
			taxExemption: {
				label: "Tax Exemption",
			},
			taxType: {
				label: "Type of tax",
			},
		},
	},
};
